(() => {
    const documents = document.querySelectorAll('[data-document-id]');
    const ducumentDownloadTrigger = document.querySelector(
        '[data-document-download-trigger]',
    );

    if (documents.length && ducumentDownloadTrigger) {
        const parts = ['/actions/squeeze/download?archivename=archive'];

        documents.forEach(document => {
            parts.push(`files[]=${document.dataset.documentId}`);
        });

        ducumentDownloadTrigger.setAttribute('href', parts.join('&'));
    }
})();

(() => {
    const printButtons = document.querySelectorAll('[data-print-button]');
    printButtons.forEach(printButton => {
        printButton.addEventListener('click', () => {
            window.print();
        });
    });
})();

(() => {
    const check = () => {
        if (window.pageYOffset > 0) {
            document.body.classList.add('has-sticky-navigation');
        } else {
            document.body.classList.remove('has-sticky-navigation');
        }

        window.requestAnimationFrame(check);
    }

    window.requestAnimationFrame(check);
})();

(() => {
    const button = document.querySelector('[data-project-header-scroll-trigger]');

    if (button) {
        button.addEventListener('click', () => {
            window.scrollTo(0, window.innerHeight);
        });
    }
})();
